import React, { useState, useEffect } from "react";
import "./MultiSelectDropdown.css";
import {
  callRecordingTickIcon,
  searchIcon,
} from "../../../utility-functions/assetLoader";
import "../../../index.css";

const MultiSelectDropdown = ({
  options = [], // ex- [{id:"", value:""}]
  selected = [], // array of IDs
  onAdd = () => null,
  onClear = () => null,
  style = {},
  firstButtonName = "Clear",
  secondButtonName = "Apply",
  maxSelected = null,
}) => {
  //States
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOptions, setSelectedOptions] = useState(selected || []);
  const [filteredOptions, setFilteredOptions] = useState(options);

  //Handlers
  const handleSelect = (id) => {
    setSelectedOptions((prev) =>
      prev.includes(id)
        ? prev.filter((item) => item !== id)
        : maxSelected && prev.length >= maxSelected
          ? prev
          : [...prev, id]
    );
  };

  const handleClear = () => {
    setSelectedOptions([]);
    onClear?.();
  };

  const handleAdd = () => {
    onAdd?.(selectedOptions);
  };

  //Effects
  useEffect(() => {
    setFilteredOptions(
      options.filter((opt) =>
        opt.value.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, options]);

  useEffect(() => {
    setSelectedOptions([...selected]);
  }, [selected]);

  return (
    <div style={style} className="dropdown-container">
      <div className="dropdown-search">
        {searchIcon()}
        <input
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="dropdown-options custom-scrollbar">
        {filteredOptions.map((option) => {
          const isChecked = selectedOptions?.includes(option.id);
          const isDisabled =
            maxSelected && selectedOptions?.length >= maxSelected && !isChecked;
          return (
            <div
              key={option.id}
              className={"dropdown-option" + (isDisabled ? " disabled" : "")}
              tabIndex={isDisabled ? -1 : 0}
              onClick={() => !isDisabled && handleSelect(option.id)}
              onKeyDown={(e) => {
                if (!isDisabled && (e.key === " " || e.key === "Enter")) {
                  e.preventDefault();
                  handleSelect(option.id);
                }
              }}
              role="checkbox"
              aria-checked={isChecked}
              aria-disabled={isDisabled}
            >
              <div
                className={`custom-checkbox${isChecked ? " checked" : ""}${isDisabled ? " disabled" : ""}`}
                aria-hidden="true"
              >
                {isChecked && callRecordingTickIcon("#ffffff")}
              </div>
              {option.value}
            </div>
          );
        })}
      </div>

      <div className="dropdown-actions">
        <button className="clear-btn" onClick={handleClear}>
          {firstButtonName}
        </button>
        <button
          disabled={selectedOptions?.length === 0}
          className={`add-btn ${selectedOptions?.length === 0 ? "disabled" : ""}`}
          onClick={handleAdd}
        >
          {secondButtonName}
        </button>
      </div>
    </div>
  );
};

export default MultiSelectDropdown;
